import { useEffect, useState } from "react";

export default function Tenants() {
  const [orgs, setOrgs] = useState([]);
  useEffect(() => {
    async function getOrgs() {
      let res = await fetch("http://localhost:3001/api/organization");
      if (res.status == 200) {
        res = await res.json();
        res = res.data;
        setOrgs(res);
      }
    }
    getOrgs();
  }, []);
  return (
    <>
      <style>
        {`
        #main-t-div {
            color: white;
            // background-color: white; 
            height: 100%;
            width: 100%;
        }
        .t-h {
            color: white;
        }
    `}
      </style>
      ;
      <div id="main-t-div">
        <h1 className="t-h">Choose your tenant</h1>
        {orgs && (
          <div className="in-t-div">
            <select>
              {orgs.map((org) => (
                <option key={org.name}>{org.name}</option>
              ))}
            </select>
            <button>Continue</button>
          </div>
        )}
      </div>
    </>
  );
}
